"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PoundIcon = void 0;
var React = _interopRequireWildcard(require("react"));
var _SvgIcon = require("../SvgIcon");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
} /**
  * This file was generated by the build:icons script
  * See Notion for details on how to add icons
  */
const PoundIcon = props => /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, _extends({}, props, {
  viewBox: "0 0 24 24"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.238 2c-3.024 0-5.19 2.765-5.19 5.879 0 1.136.169 2.177.366 3.121H6a1 1 0 1 0 0 2h1.856c.142.687.24 1.31.24 1.926 0 2.62-1.005 4.074-1.85 5.295l-.069.1a1 1 0 0 0 1.15 1.513l.005-.001.024-.008c.02-.008.053-.018.096-.032a27.767 27.767 0 0 1 1.632-.477c1.033-.268 2.24-.51 3.154-.51.764 0 1.542.27 2.473.593l.278.097c.492.17 1.036.347 1.575.439.546.092 1.155.11 1.762-.1a1 1 0 0 0-.652-1.891c-.179.062-.42.079-.776.019-.36-.061-.766-.189-1.256-.358a51.806 51.806 0 0 1-.294-.102c-.873-.307-1.984-.698-3.11-.698-.974 0-2.105.204-3.068.43.516-1.098.925-2.49.925-4.309 0-.65-.084-1.296-.2-1.926H14a1 1 0 1 0 0-2H9.46c-.225-1.019-.412-2.027-.412-3.121C9.048 5.572 10.595 4 12.238 4c1.84 0 3.805 1.268 4.25 4.038a1 1 0 1 0 1.976-.318C17.861 3.985 15.063 2 12.238 2Z"
}));
exports.PoundIcon = PoundIcon;